import React, { useState } from "react";
import { Link, useMatch, useResolvedPath } from "react-router-dom";
import "./Menu.css";
import logo from "../../assets/Al Diar - Arabic Logo - Red.png";

export default function Menu() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="menu">
      <button className="burger-menu" onClick={toggleMenu}>
        ☰
      </button>
      <Link to="/" onClick={toggleMenu} className="MN-logo">
        <img src={logo} alt="Logo" />
      </Link>
      <ul className={`menu-list ${isOpen ? "open" : ""}`}>
        <CustomLink to="/" onClick={toggleMenu}>الرئيسية</CustomLink>
        <CustomLink to="/projects" onClick={toggleMenu}>مشاريعنا</CustomLink>
        <li className="logo">
          <Link to="/">
            <img src={logo} alt="Logo" />
          </Link>
        </li>
        <CustomLink to="/Latest" onClick={toggleMenu}>احدث المشاريع السكنية</CustomLink>
        <CustomLink to="/About" onClick={toggleMenu}>عنا</CustomLink>
      </ul>
    </nav>
  );
}

function CustomLink({ to, children, ...props }) {
  const resolvedPath = useResolvedPath(to);
  const isActive = useMatch({ path: resolvedPath.pathname, end: true });

  return (
    <li className={isActive ? "active" : ""}>
      <Link to={to} {...props}>
        {children}
      </Link>
    </li>
  );
}
